import { updateLinksAttributes, isLocalUrl, validateWindowSize, missingWidget } from '../utils.js';

function getWindowSize(breakpointValue) {
  return validateWindowSize(breakpointValue);
}

function autoEventFeed() {
  const widgetName = 'autoEventFeed';
  const $widget = $(`#${widgetName}`);
  const $container = $widget;

  const widgetOpts = typeof autoEventFeedOpts === 'undefined' ? null : autoEventFeedOpts;
  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  $widget.append('<div class="multiFeatureContent"></div>');

  $widget.MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    detectIpad: IPADDETECTED,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    link: getWindowSize(800) ? [''] : ['all'],
    allEventsLink: false,
    isResponsive: false,
    lazyLoadImages: false,
    maxItemsVisible: 5,
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },

    multiFeatureLoaded: function (data) {
      if (data.length) {
        createCustomEvents(widgetName, data, $container);

        $('.all-events-btn-container').appendTo($widget);
      } else {
        $widget.remove();
      }
    },
  });
}

function createCustomEvents(widgetName, items, $container) {
  $(`#${widgetName} .featureItem`).each(function (i) {
    const $item = $(this).empty().appendTo($container);
    const { Date: dateWidget, Name, URL, ImageURL, Purchaseable } = items[i] || {};

    const dateData = parseEventDate(dateWidget);

    $item.append(buildEventInfoLayout(Name, ImageURL, URL, Purchaseable));

    if (dateData.hasDate) {
      $item
        .find('.event-info')
        .prepend(
          buildEventDateLayout(
            dateData.startMonth,
            dateData.startDay,
            dateData.endMonth,
            dateData.endDay,
          ),
        );
    } else {
      $item.find('.event-info').addClass('no-date');
    }
    applyAriaLabel($item, Name, URL, dateData);

    if (!URL) {
      $item.addClass('void-link');
    }

    if (!getWindowSize(800)) {
      setEventLink($item, URL, Name);
    }
  });
  $(`#${widgetName} .featureItem`).wrapAll('<div class="container-events"></div>');
  $(`#${widgetName} .multiFeatureContent`).remove();
}

function parseEventDate(widgetDate) {
  if (!widgetDate) {
    return { hasDate: false };
  }

  const parts = widgetDate.split('-').map((p) => p.trim());

  const start = extractDate(parts[0]);
  const end = parts[1] ? extractDate(parts[1]) : null;

  return {
    hasDate: true,
    startMonth: start.month,
    startDay: start.day,
    endMonth: end?.month || null,
    endDay: end?.day || null,
  };
}

function extractDate(str) {
  if (!str) return { month: '', day: '' };

  const clean = str.split(',')[0].trim();
  const [month, day] = clean.split(' ');

  return {
    month: month?.substring(0, 3) || '',
    day: day || '',
  };
}

function setEventLink($item, url, title) {
  updateLinksAttributes(url, title, $item);
}

function applyAriaLabel($item, title, url, dateData) {
  const dateText = buildAriaDate(dateData);
  const externalText = url && !isLocalUrl(url) ? ' (opens in a new tab)' : '';

  const label = dateText ? `${dateText} - ${title}${externalText}` : `${title}${externalText}`;

  $item.attr('aria-label', label);
}

function buildAriaDate({ hasDate, startMonth, startDay, endMonth, endDay }) {
  if (!hasDate) return '';

  const start = `${convertMonth(startMonth)} ${normalizeDay(startDay)}`;

  if (!endMonth || !endDay) return start;

  if (startMonth === endMonth) {
    return `${start} to ${normalizeDay(endDay)}`;
  }

  return `${start} to ${convertMonth(endMonth)} ${normalizeDay(endDay)}`;
}

function buildEventInfoLayout(title, imagePath, url, purchasableBtn) {
  const missingImageCheck = imagePath || `${FULLCLIENTTHEMEPATH}images/no_image_available.jpg`;
  return `
    <div class="image-container">
      <img src="${missingImageCheck}" alt="${title}">
      <div class="overlay">
      ${url ? `<a href="${url}" class="button" ${updateLinksAttributes(url, title)}>More</a>` : ''}
      ${purchasableBtn ? `<a href="${url}" class="button" ${updateLinksAttributes(url, title)}>Buy Now</a>` : ''}
      </div>
    </div>

    <div class="event-info">
      <span class="event-name">${title}</span>
    </div>
  `;
}

function buildEventDateLayout(startMonth, startDay, endMonth, endDay) {
  if (!endMonth || !endDay) {
    return `
      <div class="event-date" aria-hidden="true">
        <span class="month">${startMonth}</span>
        <span class="day">${startDay}</span>
      </div>`;
  }

  if (startMonth === endMonth) {
    return `
      <div class="event-date double-date" aria-hidden="true">
        <span class="month">${startMonth}</span>
        <span class="day">${startDay}<span class="divider">-</span>${endDay}</span>
      </div>`;
  }

  return `
    <div class="event-date date-range" aria-hidden="true">
      <div class="combo-date">
        <span class="month">${startMonth}</span>
        <span class="day">${startDay}</span>
      </div>
      <span class="divider-month">-</span>
      <div class="combo-date">
        <span class="month">${endMonth}</span>
        <span class="day">${endDay}</span>
      </div>
    </div>`;
}

const monthsFull = {
  Jan: 'January',
  Feb: 'February',
  Mar: 'March',
  Apr: 'April',
  May: 'May',
  Jun: 'June',
  Jul: 'July',
  Aug: 'August',
  Sep: 'September',
  Oct: 'October',
  Nov: 'November',
  Dec: 'December',
};

function convertMonth(month) {
  return monthsFull[month] || month;
}

function normalizeDay(day) {
  return Number.parseInt(day, 10);
}

// Rebuilds the event feed when the 800px breakpoint is crossed.
// matchMedia('change') instead of window.resize because resize fires on
// every pixel moved, causing layout thrashing and redundant rebuilds.
// matchMedia only triggers once per breakpoint crossing, so the feed rebuilds
// exactly when the layout actually needs to change.
export default function updateManualFeed() {
  const mq = globalThis.matchMedia('(max-width: 800px)');

  autoEventFeed();

  mq.addEventListener('change', () => {
    $('#autoEventFeed .container-events').remove();
    autoEventFeed();
  });
}
